module.exports = __webpack_public_path__ + "static/nasa3-frame-b11bf62c29377f1d527543253ac390af.gif";